export var defaultOptions = {
  mutate: {
    errorPolicy: "all"
  }
};